
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function OTC() {
  const [activeCategory, setActiveCategory] = useState('pain-relief');

  const categories = [
    { id: 'pain-relief', name: '解熱鎮痛・鎮静・睡眠改善薬', icon: 'ri-thermometer-line', color: 'bg-red-50 text-red-600' },
    { id: 'gastrointestinal', name: '胃腸薬', icon: 'ri-capsule-line', color: 'bg-green-50 text-green-600' },
    { id: 'respiratory', name: '呼吸器官用薬', icon: 'ri-lungs-line', color: 'bg-blue-50 text-blue-600' },
    { id: 'eye-ear-nose', name: '眼科・耳鼻科用薬', icon: 'ri-eye-line', color: 'bg-purple-50 text-purple-600' },
    { id: 'dermatology', name: '皮膚用薬', icon: 'ri-hand-sanitizer-line', color: 'bg-orange-50 text-orange-600' },
    { id: 'external-injury', name: '外傷・鎮痛・鎮痒・消毒薬', icon: 'ri-first-aid-kit-line', color: 'bg-pink-50 text-pink-600' },
    { id: 'womens-health', name: '婦人薬', icon: 'ri-heart-pulse-line', color: 'bg-rose-50 text-rose-600' },
    { id: 'circulatory', name: '循環器・血流改善薬', icon: 'ri-heart-line', color: 'bg-cyan-50 text-cyan-600' },
    { id: 'vitamins', name: 'ビタミン・栄養薬', icon: 'ri-medicine-bottle-line', color: 'bg-yellow-50 text-yellow-600' },
    { id: 'metabolism', name: '代謝改善薬', icon: 'ri-pulse-line', color: 'bg-indigo-50 text-indigo-600' },
    { id: 'urogenital', name: '泌尿生殖器官用薬', icon: 'ri-user-heart-line', color: 'bg-teal-50 text-teal-600' },
    { id: 'others', name: '駆虫薬・その他', icon: 'ri-more-line', color: 'bg-gray-50 text-gray-600' }
  ];

  const medicineData = {
    'pain-relief': {
      title: '解熱鎮痛・鎮静・睡眠改善薬',
      description: '発熱、痛み、風邪症状、乗り物酔い、不眠などに対応する薬剤',
      subcategories: [
        {
          name: '解熱鎮痛薬',
          description: '発熱や頭痛、関節痛などの痛みを和らげる',
          medicines: [
            { name: 'アセトアミノフェン系', symptoms: ['発熱', '頭痛', '軽度の痛み'], price: '600円〜', features: '胃に優しく、子供にも使用可能' },
            { name: 'イブプロフェン系', symptoms: ['関節痛', '筋肉痛', '生理痛'], price: '800円〜', features: '抗炎症作用が強い' },
            { name: 'ロキソプロフェン系', symptoms: ['強い痛み', '炎症'], price: '1,000円〜', features: '効果が強く持続時間が長い' }
          ]
        },
        {
          name: 'かぜ薬',
          description: '風邪の諸症状（発熱、鼻水、咳、のどの痛み）に対応',
          medicines: [
            { name: '総合感冒薬', symptoms: ['発熱', '鼻水', '咳', 'のどの痛み'], price: '1,200円〜', features: '複数症状に総合的に対応' },
            { name: '鼻炎特化型', symptoms: ['鼻水', '鼻づまり', 'くしゃみ'], price: '900円〜', features: '抗ヒスタミン薬配合' },
            { name: '咳止め特化型', symptoms: ['咳', '痰'], price: '800円〜', features: '鎮咳・去痰作用' }
          ]
        },
        {
          name: '鎮暈薬（乗り物酔い防止薬）',
          description: '乗り物酔いの予防と症状緩和',
          medicines: [
            { name: '予防タイプ', symptoms: ['乗り物酔い予防'], price: '700円〜', features: '乗車前30分に服用' },
            { name: '症状緩和タイプ', symptoms: ['めまい', '吐き気'], price: '800円〜', features: '酔ってからでも効果的' }
          ]
        },
        {
          name: '鎮静薬・睡眠改善薬',
          description: 'イライラや不眠の改善',
          medicines: [
            { name: '鎮静薬', symptoms: ['イライラ', '神経の興奮'], price: '1,000円〜', features: '植物由来成分配合' },
            { name: '睡眠改善薬', symptoms: ['寝つきが悪い', '眠りが浅い'], price: '1,200円〜', features: '一時的な不眠に対応' }
          ]
        }
      ]
    },
    'gastrointestinal': {
      title: '胃腸薬',
      description: '胃腸の不調、消化不良、便秘、下痢などの症状に対応',
      subcategories: [
        {
          name: '総合胃腸薬',
          description: '胃腸の総合的な不調に対応',
          medicines: [
            { name: '総合胃腸薬', symptoms: ['胃もたれ', '消化不良', '胃痛'], price: '800円〜', features: '複数の有効成分を配合' },
            { name: '漢方系胃腸薬', symptoms: ['慢性的な胃腸不調'], price: '1,200円〜', features: '体質改善も期待' }
          ]
        },
        {
          name: '制酸薬・胃粘膜保護薬',
          description: '胃酸過多や胃粘膜の保護',
          medicines: [
            { name: '制酸薬', symptoms: ['胃酸過多', '胸やけ'], price: '500円〜', features: '胃酸を中和' },
            { name: 'H2ブロッカー', symptoms: ['胃酸分泌過多'], price: '1,000円〜', features: '胃酸分泌を抑制' },
            { name: '胃粘膜保護薬', symptoms: ['胃粘膜の荒れ'], price: '800円〜', features: '胃壁を保護' }
          ]
        },
        {
          name: '整腸薬・止瀉薬・瀉下薬',
          description: '腸内環境の改善、下痢・便秘の対策',
          medicines: [
            { name: '整腸薬（乳酸菌製剤）', symptoms: ['腸内環境の乱れ'], price: '800円〜', features: '善玉菌を補給' },
            { name: '止瀉薬', symptoms: ['下痢', '軟便'], price: '600円〜', features: '腸の動きを調整' },
            { name: '瀉下薬（便秘薬）', symptoms: ['便秘'], price: '700円〜', features: '腸の蠕動運動を促進' }
          ]
        }
      ]
    },
    'respiratory': {
      title: '呼吸器官用薬',
      description: '咳、痰、のどの痛み、鼻炎などの呼吸器症状に対応',
      subcategories: [
        {
          name: '鎮咳去痰薬',
          description: '咳や痰の症状を改善',
          medicines: [
            { name: '鎮咳薬', symptoms: ['乾いた咳'], price: '800円〜', features: '咳中枢に作用' },
            { name: '去痰薬', symptoms: ['痰が絡む咳'], price: '900円〜', features: '痰を出しやすくする' },
            { name: '鎮咳去痰配合薬', symptoms: ['咳', '痰'], price: '1,000円〜', features: '両方の作用を併せ持つ' }
          ]
        },
        {
          name: 'のど・口腔用薬',
          description: 'のどの痛みや口内炎の治療',
          medicines: [
            { name: 'のどスプレー', symptoms: ['のどの痛み', '炎症'], price: '600円〜', features: '直接患部に作用' },
            { name: 'トローチ', symptoms: ['のどの痛み', '口内炎'], price: '500円〜', features: 'ゆっくり溶かして使用' },
            { name: 'うがい薬', symptoms: ['のどの殺菌'], price: '400円〜', features: '予防効果も期待' }
          ]
        },
        {
          name: '鼻炎用薬',
          description: '鼻水、鼻づまり、くしゃみなどの鼻炎症状',
          medicines: [
            { name: '鼻炎用内服薬', symptoms: ['鼻水', 'くしゃみ'], price: '800円〜', features: '抗ヒスタミン作用' },
            { name: '点鼻薬', symptoms: ['鼻づまり'], price: '600円〜', features: '血管収縮作用で即効性' }
          ]
        }
      ]
    },
    'eye-ear-nose': {
      title: '眼科・耳鼻科用薬',
      description: '目の疲れ、ドライアイ、耳の症状などに対応',
      subcategories: [
        {
          name: '眼科用薬',
          description: '目の疲れ、充血、ドライアイなど',
          medicines: [
            { name: '疲れ目用点眼薬', symptoms: ['目の疲れ', 'かすみ'], price: '600円〜', features: 'ビタミン配合' },
            { name: '充血除去点眼薬', symptoms: ['目の充血'], price: '500円〜', features: '血管収縮作用' },
            { name: 'ドライアイ用点眼薬', symptoms: ['目の乾燥'], price: '800円〜', features: '涙液成分補充' }
          ]
        },
        {
          name: 'コンタクトレンズ用品',
          description: 'コンタクトレンズ装着時の不快感軽減',
          medicines: [
            { name: '装着液', symptoms: ['装着時の不快感'], price: '400円〜', features: 'レンズを滑らかに' },
            { name: 'コンタクト用点眼薬', symptoms: ['装着中の乾燥'], price: '700円〜', features: 'レンズの上からでも使用可' }
          ]
        },
        {
          name: '耳鼻用薬',
          description: '耳の症状や鼻の局所治療',
          medicines: [
            { name: '点耳薬', symptoms: ['耳垢', '耳の炎症'], price: '600円〜', features: '耳垢を柔らかくする' }
          ]
        }
      ]
    },
    'dermatology': {
      title: '皮膚用薬',
      description: '皮膚炎、かゆみ、水虫、にきびなどの皮膚トラブルに対応',
      subcategories: [
        {
          name: '皮膚炎・かゆみ用薬',
          description: '湿疹、皮膚炎、かゆみの治療',
          medicines: [
            { name: 'ステロイド外用薬', symptoms: ['湿疹', '皮膚炎'], price: '800円〜', features: '抗炎症作用が強い' },
            { name: '抗ヒスタミン外用薬', symptoms: ['かゆみ'], price: '600円〜', features: 'かゆみを抑制' },
            { name: '非ステロイド抗炎症薬', symptoms: ['軽度の炎症'], price: '700円〜', features: 'ステロイドを避けたい方に' }
          ]
        },
        {
          name: 'しもやけ・あかぎれ用薬',
          description: '寒冷による皮膚トラブル',
          medicines: [
            { name: 'しもやけ用薬', symptoms: ['しもやけ', '血行不良'], price: '600円〜', features: '血行促進作用' },
            { name: 'あかぎれ用薬', symptoms: ['ひび割れ', 'あかぎれ'], price: '500円〜', features: '保湿・修復作用' }
          ]
        },
        {
          name: 'にきび・水虫用薬',
          description: 'にきびや真菌感染症の治療',
          medicines: [
            { name: 'にきび治療薬', symptoms: ['にきび', '吹出物'], price: '800円〜', features: '殺菌・角質溶解作用' },
            { name: '水虫薬', symptoms: ['水虫', 'たむし'], price: '1,000円〜', features: '抗真菌作用' }
          ]
        },
        {
          name: '皮膚殺菌消毒薬',
          description: '皮膚の殺菌・消毒',
          medicines: [
            { name: '皮膚殺菌薬', symptoms: ['皮膚の殺菌'], price: '400円〜', features: '広範囲の細菌に効果' }
          ]
        }
      ]
    },
    'external-injury': {
      title: '外傷・鎮痛・鎮痒・消毒薬',
      description: 'けが、打撲、虫刺され、消毒などの外用治療',
      subcategories: [
        {
          name: 'きず薬・消毒薬',
          description: '外傷の治療と感染予防',
          medicines: [
            { name: 'きず薬', symptoms: ['切り傷', 'すり傷'], price: '600円〜', features: '傷の治癒を促進' },
            { name: '消毒薬', symptoms: ['傷口の殺菌'], price: '400円〜', features: '感染予防' }
          ]
        },
        {
          name: '打撲・ねんざ用薬',
          description: '打撲やねんざの痛み・腫れの軽減',
          medicines: [
            { name: '湿布薬（冷感）', symptoms: ['急性の打撲', 'ねんざ'], price: '800円〜', features: '冷却・鎮痛作用' },
            { name: '湿布薬（温感）', symptoms: ['慢性の痛み', 'こり'], price: '800円〜', features: '血行促進・鎮痛作用' },
            { name: '塗り薬', symptoms: ['筋肉痛', '関節痛'], price: '700円〜', features: '患部に直接塗布' }
          ]
        },
        {
          name: '鎮痒消炎外用薬',
          description: '虫刺されやかゆみの治療',
          medicines: [
            { name: '虫刺され薬', symptoms: ['虫刺され', 'かゆみ'], price: '500円〜', features: '抗ヒスタミン・ステロイド配合' }
          ]
        }
      ]
    },
    'womens-health': {
      title: '婦人薬',
      description: '生理痛、更年期障害、貧血などの女性特有の症状に対応',
      subcategories: [
        {
          name: '婦人薬',
          description: '生理痛や更年期障害の症状緩和',
          medicines: [
            { name: '生理痛薬', symptoms: ['生理痛', '月経困難症'], price: '800円〜', features: '鎮痛・鎮痙作用' },
            { name: '更年期障害薬', symptoms: ['のぼせ', 'イライラ'], price: '1,200円〜', features: '漢方薬が中心' }
          ]
        },
        {
          name: '貧血用薬',
          description: '鉄分不足による貧血の改善',
          medicines: [
            { name: '鉄剤', symptoms: ['貧血', '立ちくらみ'], price: '1,000円〜', features: '鉄分補給' }
          ]
        }
      ]
    },
    'circulatory': {
      title: '循環器・血流改善薬',
      description: '血行不良、冷え性、軽度の血圧上昇などに対応',
      subcategories: [
        {
          name: '強心薬・血行改善薬',
          description: '心臓機能のサポートと血流改善',
          medicines: [
            { name: '強心薬', symptoms: ['動悸', '息切れ'], price: '1,200円〜', features: '心臓機能をサポート' },
            { name: '血流改善薬', symptoms: ['冷え性', '末梢循環不良'], price: '1,000円〜', features: '血行を促進' }
          ]
        }
      ]
    },
    'vitamins': {
      title: 'ビタミン・栄養薬',
      description: 'ビタミン不足、疲労回復、滋養強壮に対応',
      subcategories: [
        {
          name: 'ビタミン製剤',
          description: 'ビタミン不足の補給',
          medicines: [
            { name: 'ビタミンB群', symptoms: ['疲労', '神経痛'], price: '800円〜', features: 'エネルギー代謝をサポート' },
            { name: 'ビタミンC', symptoms: ['風邪予防', '美肌'], price: '600円〜', features: '抗酸化作用' },
            { name: 'マルチビタミン', symptoms: ['栄養不足'], price: '1,000円〜', features: '総合的な栄養補給' }
          ]
        },
        {
          name: '滋養強壮薬',
          description: '疲労回復と体力増強',
          medicines: [
            { name: '滋養強壮ドリンク', symptoms: ['疲労', '体力低下'], price: '200円〜', features: '即効性が期待できる' },
            { name: '滋養強壮錠', symptoms: ['慢性疲労'], price: '1,500円〜', features: '継続的な体力向上' }
          ]
        },
        {
          name: '肝臓用薬',
          description: '肝機能のサポート',
          medicines: [
            { name: '肝臓用薬', symptoms: ['肝機能低下', '二日酔い'], price: '1,200円〜', features: '肝臓の働きをサポート' }
          ]
        }
      ]
    },
    'metabolism': {
      title: '代謝改善薬',
      description: '軽度の糖尿病、高コレステロール、痛風などの代謝異常に対応',
      subcategories: [
        {
          name: '代謝改善薬',
          description: '生活習慣病の軽度症状に対応',
          medicines: [
            { name: '血糖値改善薬', symptoms: ['軽度の血糖値上昇'], price: '1,500円〜', features: '食後血糖値の上昇を抑制' },
            { name: 'コレステロール改善薬', symptoms: ['軽度の高コレステロール'], price: '1,200円〜', features: 'コレステロール値の改善' },
            { name: '尿酸値改善薬', symptoms: ['軽度の高尿酸血症'], price: '1,000円〜', features: '尿酸の排泄を促進' }
          ]
        }
      ]
    },
    'urogenital': {
      title: '泌尿生殖器官用薬',
      description: '頻尿、排尿障害、男性機能の改善に対応',
      subcategories: [
        {
          name: '泌尿器用薬',
          description: '排尿に関する症状の改善',
          medicines: [
            { name: '頻尿改善薬', symptoms: ['頻尿', '尿漏れ'], price: '1,200円〜', features: '膀胱機能を改善' },
            { name: '排尿困難改善薬', symptoms: ['排尿困難'], price: '1,000円〜', features: '前立腺肥大による症状に' }
          ]
        },
        {
          name: '強壮薬',
          description: '男性機能の改善',
          medicines: [
            { name: '強壮薬', symptoms: ['精力減退'], price: '1,500円〜', features: '男性機能をサポート' }
          ]
        }
      ]
    },
    'others': {
      title: '駆虫薬・その他',
      description: '寄生虫、歯槽膿漏、脱毛、制汗などの特殊な症状に対応',
      subcategories: [
        {
          name: '駆虫薬',
          description: '寄生虫の駆除',
          medicines: [
            { name: '駆虫薬', symptoms: ['寄生虫感染'], price: '800円〜', features: '腸内寄生虫を駆除' }
          ]
        },
        {
          name: '歯槽膿漏薬・口腔衛生薬',
          description: '歯茎の健康維持',
          medicines: [
            { name: '歯槽膿漏薬', symptoms: ['歯茎の腫れ', '出血'], price: '800円〜', features: '歯茎の炎症を抑制' },
            { name: '口臭防止薬', symptoms: ['口臭'], price: '600円〜', features: '口腔内の殺菌' }
          ]
        },
        {
          name: 'その他',
          description: '脱毛、制汗、その他の症状',
          medicines: [
            { name: '脱毛薬', symptoms: ['男性型脱毛症'], price: '5,000円〜', features: '発毛促進' },
            { name: '制汗薬', symptoms: ['多汗'], price: '800円〜', features: '汗の分泌を抑制' }
          ]
        }
      ]
    }
  };

  const currentContent = medicineData[activeCategory];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-purple-50 to-blue-50 py-16">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            OTC<span className="text-purple-600">医薬品販売</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            48薬効群に基づいた症状別市販薬の適切な選択をサポートし、安全で効果的な使用方法をご案内します
          </p>
          <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 max-w-4xl mx-auto">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">OTC医薬品48薬効群対応</h3>
            <p className="text-gray-600">
              厚生労働省が定める48薬効群の分類に基づき、症状に最適な市販薬をご提案いたします
            </p>
          </div>
        </div>
      </section>

      {/* Category Navigation */}
      <section className="py-8 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex flex-col items-center p-4 rounded-xl font-medium transition-all cursor-pointer ${
                  activeCategory === category.id
                    ? 'bg-purple-600 text-white shadow-lg'
                    : 'bg-gray-50 text-gray-700 hover:bg-purple-50 hover:text-purple-600'
                }`}
              >
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-2 ${
                  activeCategory === category.id ? 'bg-white/20' : category.color
                }`}>
                  <i className={`${category.icon} text-xl ${activeCategory === category.id ? 'text-white' : ''}`}></i>
                </div>
                <span className="text-xs text-center leading-tight">{category.name}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{currentContent.title}</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">{currentContent.description}</p>
          </div>

          {currentContent.subcategories.map((subcategory, index) => (
            <div key={index} className="mb-16">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{subcategory.name}</h3>
                <p className="text-gray-600">{subcategory.description}</p>
              </div>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {subcategory.medicines.map((medicine, idx) => (
                  <div key={idx} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100 overflow-hidden">
                    <div className="p-6">
                      <h4 className="text-xl font-bold text-gray-900 mb-3">{medicine.name}</h4>
                      <p className="text-gray-600 mb-4">{medicine.features}</p>
                      <div className="mb-4">
                        <h5 className="text-sm font-semibold text-gray-700 mb-2">対象症状:</h5>
                        <div className="flex flex-wrap gap-1">
                          {medicine.symptoms.map((symptom, symptomIdx) => (
                            <span key={symptomIdx} className="bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded-full">
                              {symptom}
                            </span>
                          ))}
                        </div>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-lg font-bold text-purple-600">{medicine.price}</span>
                        <a 
                          href="https://rpx.a8.net/svt/ejp?a8mat=45BKFB+W5FG2+2HOM+6C1VM&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2F0ea62065.34400275.0ea62066.204f04c0%2Fa25080201428_45BKFB_W5FG2_2HOM_6C1VM%3Fpc%3Dhttp%253A%252F%252Fwww.rakuten.co.jp%252F&m=http%3A%2F%2Fm.rakuten.co.jp%2F"
                          rel="nofollow"
                          target="_blank"
                          className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors whitespace-nowrap cursor-pointer"
                        >
                          楽天で購入
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Rakuten Affiliate Section */}
      <section className="py-16 bg-gradient-to-br from-red-50 to-pink-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">OTC医薬品のお求めは</h2>
          <p className="text-lg text-gray-600 mb-8">
            48薬効群対応の豊富な品揃えと安心の品質で、PharmaBeastのコンテンツ
します
          </p>
          <div className="flex flex-col items-center gap-6">
            <a 
              href="https://rpx.a8.net/svt/ejp?a8mat=45BKFB+W5FG2+2HOM+68MF5&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2F0ea62065.34400275.0ea62066.204f04c0%2Fa25080201428_45BKFB_W5FG2_2HOM_68MF5%3Fpc%3Dhttp%253A%252F%252Fwww.rakuten.co.jp%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252F"
              rel="nofollow"
              target="_blank"
              className="cursor-pointer"
            >
              <img src="http://hbb.afl.rakuten.co.jp/hsb/0eb4bbc2.1a81da3f.0eb4bbaa.95151395/" border="0" alt="楽天バナー" />
            </a>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="https://rpx.a8.net/svt/ejp?a8mat=45BKFB+W5FG2+2HOM+6C1VM&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2F0ea62065.34400275.0ea62066.204f04c0%2Fa25080201428_45BKFB_W5FG2_2HOM_6C1VM%3Fpc%3Dhttp%253A%252F%252Fwww.rakuten.co.jp%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252F"
                rel="nofollow"
                target="_blank"
                className="bg-red-600 text-white px-12 py-4 rounded-full text-xl font-bold hover:bg-red-700 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
              >
                楽天で医薬品を探す
              </a>
              <a 
                href="//ck.jp.ap.valuecommerce.com/servlet/referral?sid=3755218&pid=892142085"
                rel="nofollow"
                target="_blank"
                className="bg-blue-600 text-white px-12 py-4 rounded-full text-xl font-bold hover:bg-blue-700 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
              >
                Yahoo!ショッピングで探す
              </a>
            </div>
          </div>
          <img 
            width="1" 
            height="1" 
            src="https://www12.a8.net/0.gif?a8mat=45BKFB+W5FG2+2HOM+6C1VM" 
            alt=""
            className="hidden"
          />
          <img 
            border="0" 
            width="1" 
            height="1" 
            src="https://www13.a8.net/0.gif?a8mat=45BKFB+W5FG2+2HOM+68MF5" 
            alt=""
            className="hidden"
          />
          <img 
            src="//ad.jp.ap.valuecommerce.com/servlet/gifbanner?sid=3755218&pid=892142085" 
            height="1" 
            width="1" 
            border="0"
            alt=""
            className="hidden"
          />
        </div>
      </section>

      {/* 48 Drug Categories Overview */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">OTC医薬品48薬効群一覧</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categories.map((category, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6">
                <div className={`w-12 h-12 rounded-lg ${category.color} flex items-center justify-center mb-4`}>
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{category.name}</h3>
                <div className="space-y-1">
                  {medicineData[category.id].subcategories.map((sub, idx) => (
                    <p key={idx} className="text-sm text-gray-600">• {sub.name}</p>
                  ))}
                </div>
                <button
                  onClick={() => setActiveCategory(category.id)}
                  className="mt-4 text-purple-600 font-medium hover:text-purple-700 cursor-pointer"
                >
                  詳細を見る →
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Safety Information */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">安全な使用のために</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-12 h-12 bg-red-50 text-red-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-alert-line text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">用法・用量を守る</h3>
              <p className="text-gray-600 text-sm">決められた量と回数を必ず守って服用してください</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-12 h-12 bg-yellow-50 text-yellow-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">服用期間の確認</h3>
              <p className="text-gray-600 text-sm">症状が改善しない場合は医師にご相談ください</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-12 h-12 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-medicine-bottle-line text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">飲み合わせ注意</h3>
              <p className="text-gray-600 text-sm">他の薬との相互作用にご注意ください</p>
            </div>
            <div className="bg-white rounded-xl shadow-lg p-6 text-center">
              <div className="w-12 h-12 bg-green-50 text-green-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-heart-line text-xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">薬剤師に相談</h3>
              <p className="text-gray-600 text-sm">不明な点は遠慮なく薬剤師にお尋ねください</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-support" className="hover:text-white cursor-pointer">健康サポート</Link></li>
                <li><Link to="/self-care" className="hover:text-white cursor-pointer">セルフケア</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/pharmacist-resources" className="hover:text-white cursor-pointer">専門リソース</Link></li>
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/information" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/guidelines" className="hover:text-white cursor-pointer">疾患ガイドライン</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
